// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YTej","placeholdersHeader":"styles_placeholdersHeader__O0uik","editorStyle":"styles_editorStyle__3lo12","placeholdersBox":"styles_placeholdersBox__1zWam"};